exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 1900px) {\n.drugs-types[data-v-27bc1a8e] {\n        margin-left: 100px !important;\n        margin-right: 100px !important;\n}\n}\n", ""]);

// exports
